import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from "@sentry/react"
import { Integrations } from "@sentry/tracing"
import {Provider} from 'react-redux'
import {ConnectedRouter} from 'react-router-redux'
import {MuiThemeProvider} from 'material-ui/styles'
import {theme} from './theme'
import config from './config'

// import registerServiceWorker from './registerServiceWorker'
import {unregister} from './registerServiceWorker'
// import injectTapEventPlugin from 'react-tap-event-plugin'

import './index.css'
import App from './App'
import store, {history} from './state/store'

// injectTapEventPlugin()

Sentry.init({
  dsn: "https://6c9a5e4362164659a08cd1628ff15245@o336113.ingest.sentry.io/5660115",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1,
})

console.log(config.ENV)
ReactDOM.render((
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <ConnectedRouter history={history}>
        <App/>
      </ConnectedRouter>
    </MuiThemeProvider>
  </Provider>
), document.getElementById('root'))

// The service worker is causing routes like /guest.html to be resolved locally instead of going to the server.
// For this reason, going to /guest.html takes you to "/" given that the route is obviously not declared in app.js
// To reproduce this behaviour, do the following:
//    1. open "/guest.html" OK
//    2. change url to "/" OK
//    3. change url back to "/guest.html" -> redirects to "/" NOT OK
// This messes up the iframe in space.guru, as it ends up loading the site itself instead of guest.html. This
// happens if you have at least one tab open with "/" or any other url that is locally handled.
// This issue should be resolved before using the service worker again.
unregister()



// WEBPACK FOOTER //
// ./src/index.js